export enum DocumentEditorType {
  TREATMENT = 'TREATMENT',
  APP_ASSESSMENT = 'APP_ASSESSMENT',
  COVID_ASSESSMENT = 'COVID_ASSESSMENT',
  AI_ASSESSMENT = 'AI_ASSESSMENT',
  GLOBAL_MEASURE_CHECK = 'GLOBAL_MEASURE_CHECK'
}
